<template>
  <div>
    <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
      </div>
      <div class="company-box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="互联网造车" name="first">
            <div class="company">
              <el-link
                v-for="(item, index) of internetCar"
                :key="index"
                :href="'/enterprise/#/Inside?name=' + item"
                target="_blank"
                >{{ item }}</el-link
              >
            </div>
          </el-tab-pane>
          <el-tab-pane label="造车新势力" name="second">
            <div class="company">
              <el-link
                v-for="(item, index) of newForce"
                :key="index"
                :href="'/enterprise/#/Inside?name=' + item"
                target="_blank"
                >{{ item }}</el-link
              >
            </div>
          </el-tab-pane>
          <el-tab-pane label="传统车企" name="third">
            <div class="company">
              <el-link
                v-for="(item, index) of traditional"
                :key="index"
                :href="'/enterprise/#/Inside?name=' + item"
                target="_blank"
                >{{ item }}</el-link
              >
            </div>
          </el-tab-pane>
          <el-tab-pane label="汽车电商" name="fourth">
            <div class="company">
              <el-link
                v-for="(item, index) of carEcommerce"
                :key="index"
                :href="'/enterprise/#/Inside?name=' + item"
                target="_blank"
                >{{ item }}</el-link
              >
            </div>
          </el-tab-pane>
          <el-tab-pane label="汽车后市场" name="fifth">
            <div class="company">
              <el-link
                v-for="(item, index) of afterMarket"
                :key="index"
                :href="'/enterprise/#/Inside?name=' + item"
                target="_blank"
                >{{ item }}</el-link
              >
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <Email />

    <div class="right-box">
      <div class="right-title">
        <span>网经社车行天下台</span>
      </div>
      <div style="width: 300px">
        <a href="/Index/wjs_search_res.html?kw=汽车" target="_blank">
          <img style="width: 100%" src="/Public/tuku/6a5e01e37a711.jpg" />
        </a>
      </div>
    </div>

    <div class="right-box">
      <div class="right-title">
        <span>热门投诉</span>
        <a href="/Index/complain.html" target="_blank">我要投诉</a>
      </div>
      <ul class="platform">
        <li
          v-for="(item, index) of hotComplaints"
          :key="index"
          @click="getPlatform(index)"
        >
          {{ item }}
          <i class="fa fa-fire fa-lg"></i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentR",
  data() {
    return {
      activeName: "first",
      internetCar: [
        "小米汽车",
        "华为汽车",
        "字节跳动",
        "京东",
        "抖音",
        "百度",
        "腾讯",
        "阿里巴巴"
      ],
      newForce: [
        "特斯拉",
        "比亚迪",
        "极氪",
        "理想汽车",
        "蔚来",
        "小鹏汽车",
        "零跑汽车",
        "深蓝汽车",
        "智己汽车",
        "阿维塔",
        "腾势",
        "昊铂",
        "极狐"
      ],
      traditional: [
        "吉利汽车",
        "广汽集团",
        "上汽集团",
        "长安汽车",
        "一汽集团",
        "长城汽车",
        "宝马",
        "奔驰",
        "奥迪"
      ],
      carEcommerce: [
        "瓜子二手车",
        "优信",
        "人人车",
        "天天拍车",
        "淘车车",
        "卖好车",
        "大搜车"
      ],
      afterMarket: [
        "途虎养车",
        "天猫养车",
        "京东养车",
        "车享家",
        "车点点",
        "易捷养车",
        "租租车",
        "神州租车",
        "一嗨租车",
        "悟空租车"
      ],
      hotComplaints: [
         "瓜子二手车",
        "途虎养车",
        "优信",
        "大搜车",
        "人人车",
        "弹个车",
        "天天拍车",
        "享车",
        "养车无忧网",
        "毛豆新车网",
        "斯柯达",
        "特斯拉",
        "比亚迪",
        "蔚来",
        "小鹏",
        "理想",
       
      ]
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleClick(tab, event) {},
    getPlatform(index) {
      window.open(
        "/Index/complain_search.html?company=" + this.hotComplaints[index]
      );
    },
  },
};
</script>